// extracted by mini-css-extract-plugin
module.exports = {"container":"ControlPanel_container__3H3_3","tabs":"ControlPanel_tabs__3SamW","header":"ControlPanel_header__3qABJ","description":"ControlPanel_description__37HUU"};